module.exports = __webpack_public_path__ + "img/industry-img1.849fd0eb.png";